import { fetch, fetchAll } from "../services/api";

const getServicesByHotelAndType = (hotelId, typeItems) => {
    console.log('TODO - getServicesByHotelAndType')
    // return fetchAll(listItems, {
    //     filter: {
    //         hotelId: { eq: hotelId },
    //         type: { eq: typeItems },
    //         visible: { eq: true }
    //     }
    // }, 200)
    //     .then(r => {
    //         if (r.data) {
    //             return r.data;
    //         }
    //         throw new Error('getServicesByHotelAndType-error')
    //     }).catch((response) => {
    //         console.log('error', response)
    //     });
}

const getBookableItemsByHotel = (hotelId) => {
    console.log('TODO - getBookableItemsByHotel')
    // return fetch(bookableItemsByOrder, {
    //     hotelId: hotelId
    // })
    //     .then(r => {
    //         if (r.data?.BookableItemsByOrder?.items) {
    //             return r.data.BookableItemsByOrder.items;
    //         }
    //         throw new Error('getBookableItems-error')
    //     }).catch((response) => {
    //         console.log('error', response)
    //     });
}

const getBookableItemHotel = (id) => {
    console.log('TODO - getBookableItemHotel')
    // return fetch(getBookableItemQuery, {
    //     id: id
    // })
    //     .then(r => {
    //         if (r.data?.getBookableItem?.id) {
    //             return r.data.getBookableItem;
    //         }
    //         throw new Error('getBookableItem-error')
    //     }).catch((response) => {
    //         console.log('error', response)
    //     });
}

const getBookableItemReservations = (bookableItemId, from, to) => {
    console.log('TODO - getBookableItemReservations')
    // return fetch(BookableInventoryByBookableItemId, { bookableItemId: bookableItemId, day: { between: [from, to] } })
    //     .then(r => {
    //         return r.data?.BookableInventoryByBookableItemId?.items || [];
    //     })
}

export {
    getServicesByHotelAndType,
    getBookableItemsByHotel,
    getBookableItemHotel,
    getBookableItemReservations
}